import { __awaiter, __generator, __read } from "tslib";
import { Avatar, Body1, Caption1, Card, CardHeader, CardPreview, mergeClasses, Text, tokens, } from '@fluentui/react-components';
import { createActivityItem } from '@office-start/activity-control';
import { getActivityIconFromReasonType } from '@office-start/activity-utility';
import { ActionsMenuButton, RightClickActionsMenu, useActionsMenuRenderer, } from '@office-start/document-control';
import DocumentIconControl from '@office-start/document-icon-control';
import { ActivityNumLines, } from '@office-start/document-types';
import { getKey, KeyboardKey } from '@office-start/keystroke-handler-utility';
import { getLocalizedDateStringDefault, useTransformDateTimeString, } from '@office-start/loc-service';
import { format } from '@office-start/string-formatter-utility';
import React, { forwardRef, useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { useCardStyles } from './RecommendedCardControl.styles';
export var RecommendedFileCardControl = forwardRef(function (_a, ref) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var dateResources = _a.dateResources, documentActions = _a.documentActions, getDocumentThumbnail = _a.getDocumentThumbnail, item = _a.item, moreActionsButtonAriaLabel = _a.moreActionsButtonAriaLabel, onDocClick = _a.onDocClick, preferredCulture = _a.preferredCulture, getPersonPicture = _a.getPersonPicture, PeopleCard = _a.PeopleCard, edgeworthItemResources = _a.edgeworthItemResources, recommendedSectionResources = _a.recommendedSectionResources;
    var cardClasses = useCardStyles();
    var _o = __read(useState(undefined), 2), personPictureUrl = _o[0], setPersonPictureUrl = _o[1];
    useEffect(function () {
        var isMounted = true;
        var getUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!getPersonPicture) return [3 /*break*/, 2];
                        return [4 /*yield*/, getPersonPicture(item)];
                    case 1:
                        url = _a.sent();
                        if (isMounted && url) {
                            setPersonPictureUrl("data:image/png;base64,".concat(url));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        getUrl();
        return function () {
            isMounted = false;
        };
    }, [getPersonPicture, item]);
    var _p = __read(useState(undefined), 2), documentThumbnailUrl = _p[0], setDocumentThumbnailUrl = _p[1];
    useEffect(function () {
        var isMounted = true;
        var getThumbnail = function () { return __awaiter(void 0, void 0, void 0, function () {
            var thumbnailUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!getDocumentThumbnail) return [3 /*break*/, 2];
                        return [4 /*yield*/, getDocumentThumbnail(item)];
                    case 1:
                        thumbnailUrl = _a.sent();
                        if (isMounted && thumbnailUrl) {
                            setDocumentThumbnailUrl(thumbnailUrl);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        getThumbnail();
        return function () {
            isMounted = false;
        };
    }, [getDocumentThumbnail, item]);
    var _q = __read(useState(false), 2), thumbnailErrored = _q[0], setThumbnailErrored = _q[1];
    var handleThumbnailError = function () {
        setThumbnailErrored(true);
    };
    var componentRef = useRef(null);
    var timestamp = (_b = item.activity) === null || _b === void 0 ? void 0 : _b.timestamp;
    var fallbackText = timestamp
        ? getLocalizedDateStringDefault(timestamp, preferredCulture)
        : undefined;
    var transformToDateTimeString = useTransformDateTimeString(dateResources, preferredCulture);
    var formatString = (_d = (_c = item.activity) === null || _c === void 0 ? void 0 : _c.formatString) !== null && _d !== void 0 ? _d : '';
    var people = useMemo(function () {
        var _a;
        if (!!item.activity) {
            return (_a = item.activity) === null || _a === void 0 ? void 0 : _a.people;
        }
        return [];
    }, [item.activity]);
    var id = item.activity ? (_e = item.activity) === null || _e === void 0 ? void 0 : _e.id : ' ';
    var isFileAccessedByMe = ((_f = item.activity) === null || _f === void 0 ? void 0 : _f.people) && ((_g = item.activity) === null || _g === void 0 ? void 0 : _g.people.length) === 0
        ? true
        : false;
    var activityIcon = getActivityIconFromReasonType((_h = item.activity) === null || _h === void 0 ? void 0 : _h.reasonType, isFileAccessedByMe);
    var activityItem = useMemo(function () {
        return createActivityItem(formatString, ActivityNumLines.Two, transformToDateTimeString(timestamp, false, fallbackText, false), people, id, undefined, undefined, false, PeopleCard);
    }, [
        fallbackText,
        formatString,
        id,
        people,
        timestamp,
        transformToDateTimeString,
        PeopleCard,
    ]);
    var actionMenuItems = (documentActions === null || documentActions === void 0 ? void 0 : documentActions.actionMenuItems) || [];
    var contentActionsEnabled = documentActions === null || documentActions === void 0 ? void 0 : documentActions.contentActionsEnabled;
    var contentActionsGroupInfo = documentActions === null || documentActions === void 0 ? void 0 : documentActions.contentActionsGroupInfo;
    var actionsMenuRenderingPhase = useActionsMenuRenderer(componentRef);
    var AvatarElement = useMemo(function () {
        var _a, _b;
        return (React.createElement(Avatar, { image: { src: personPictureUrl || '' }, color: "colorful", className: cardClasses.avatar, name: (_b = (_a = item.activity) === null || _a === void 0 ? void 0 : _a.people[0]) === null || _b === void 0 ? void 0 : _b.name, badge: {
                className: cardClasses.badge,
                icon: activityIcon,
            } }));
    }, [
        personPictureUrl,
        cardClasses.avatar,
        cardClasses.badge,
        (_j = item.activity) === null || _j === void 0 ? void 0 : _j.people,
        activityIcon,
    ]);
    var onKeyPress = useCallback(function (e) {
        var key = getKey(e);
        if (key !== KeyboardKey.Enter && key !== KeyboardKey.Space) {
            return;
        }
        onDocClick();
    }, [onDocClick]);
    var fileCardWithHelperTextAriaLabel = format((_k = recommendedSectionResources === null || recommendedSectionResources === void 0 ? void 0 : recommendedSectionResources.fileCardAriaLabel) !== null && _k !== void 0 ? _k : '', ((_l = item.activity) === null || _l === void 0 ? void 0 : _l.plainText) || '', item.title, item.fileType || '', activityItem.timeStamp ? activityItem.timeStamp : '', (recommendedSectionResources === null || recommendedSectionResources === void 0 ? void 0 : recommendedSectionResources.enterCardHelperText) || '', (recommendedSectionResources === null || recommendedSectionResources === void 0 ? void 0 : recommendedSectionResources.exitCardHelperText) || '');
    return (React.createElement("div", { ref: componentRef },
        React.createElement(Card, { className: mergeClasses(cardClasses.root, cardClasses.fileRoot), id: item.id, "aria-label": fileCardWithHelperTextAriaLabel, role: "group", tabIndex: 0, ref: ref, focusMode: "no-tab" },
            React.createElement(CardHeader, { className: cardClasses.header, image: isFileAccessedByMe ? (React.createElement("div", { className: cardClasses.activityIcon }, activityIcon)) : (React.createElement(React.Fragment, null, PeopleCard ? (React.createElement(PeopleCard, { upn: item.activity.people &&
                        item.activity.people.length
                        ? item.activity.people[0]
                            .upn
                        : '' }, AvatarElement)) : (AvatarElement))), header: React.createElement(Body1, { className: mergeClasses(cardClasses.text, cardClasses.truncateText, cardClasses.fileHeaderTitle, !isFileAccessedByMe
                        ? cardClasses.nameMargin
                        : undefined), title: ((_m = item.activity) === null || _m === void 0 ? void 0 : _m.plainText) || '', block: true }, activityItem.activityDescription), description: React.createElement(Caption1, { className: mergeClasses(cardClasses.headerDescription, !isFileAccessedByMe
                        ? cardClasses.nameMargin
                        : undefined) }, activityItem.timeStamp), action: actionMenuItems.length > 0 &&
                    actionsMenuRenderingPhase ? (React.createElement("div", { className: mergeClasses(cardClasses.actionsButtonDisplay, 'show') },
                    React.createElement(ActionsMenuButton, { actions: actionMenuItems, ariaLabel: moreActionsButtonAriaLabel, contentActionsEnabled: contentActionsEnabled, groupInfo: contentActionsGroupInfo, item: item }))) : null }),
            React.createElement("div", { className: cardClasses.fileInnerDiv },
                React.createElement("div", { className: mergeClasses(cardClasses.secondHeadingBase, cardClasses.fileSecondHeading) },
                    React.createElement(DocumentIconControl, { item: item, iconSize: "24x24" }),
                    React.createElement(Text, { as: "h3", className: mergeClasses(cardClasses.text, cardClasses.title, cardClasses.truncateText) }, item.title)),
                React.createElement(CardPreview, { className: cardClasses.filePreview, onClick: onDocClick, onKeyDown: onKeyPress, tabIndex: 0, role: "link" }, documentThumbnailUrl && !thumbnailErrored ? (React.createElement("div", { className: cardClasses.fileImageContainer },
                    React.createElement("img", { className: cardClasses.fileImageThumbnail, src: documentThumbnailUrl, alt: item.title, onError: handleThumbnailError }),
                    React.createElement("div", { className: cardClasses.overlay }),
                    item.mediaDuration ? (React.createElement("div", { className: cardClasses.mediaDuration },
                        React.createElement(Body1, null, item.mediaDuration))) : null)) : (React.createElement("div", { className: cardClasses.fileImageErrorThumbnail, style: {
                        display: 'flex',
                        backgroundColor: tokens.colorNeutralBackground4,
                    } },
                    React.createElement(DocumentIconControl, { item: item, iconSize: "64x64", customIconAltText: edgeworthItemResources === null || edgeworthItemResources === void 0 ? void 0 : edgeworthItemResources.customIconAltText })))))),
        actionMenuItems.length > 0 && actionsMenuRenderingPhase ? (React.createElement(RightClickActionsMenu, { actions: actionMenuItems, componentRef: componentRef, contentActionsEnabled: contentActionsEnabled, groupInfo: contentActionsGroupInfo, item: item })) : null));
});
RecommendedFileCardControl.displayName = 'RecommendedFileCardControl';
//# sourceMappingURL=RecommendedFileCardControl.js.map